var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsNumber, IsOptional, IsUUID } from 'class-validator';
import { Role } from '../../roles/index.js';
export class OfficeLiteDto {
    id;
    createdAt;
    updatedAt;
    deletedAt;
    isActive;
    mainAdminId;
    hasAtLeastOneVideoCall;
    index;
    isPinoTestOffice;
}
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], OfficeLiteDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Date)
], OfficeLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLiteDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], OfficeLiteDto.prototype, "deletedAt", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], OfficeLiteDto.prototype, "isActive", void 0);
__decorate([
    IsUUID(),
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Object)
], OfficeLiteDto.prototype, "mainAdminId", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], OfficeLiteDto.prototype, "hasAtLeastOneVideoCall", void 0);
__decorate([
    Exclude(),
    IsNumber(),
    __metadata("design:type", Number)
], OfficeLiteDto.prototype, "index", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], OfficeLiteDto.prototype, "isPinoTestOffice", void 0);
//# sourceMappingURL=office.lite.dto.js.map